import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "src/utils/constants";
import { RootState } from "src/redux/store";
import { Mutex } from "async-mutex";
import {
  authTokenKeyName,
  refreshTokenKeyName,
  clearLocalStorage,
} from "src/utils/configs/authConfig";
import { setAccessToken, setRefreshToken } from "src/redux/slices/AuthSlice";
import { v4 as uuid } from "uuid";

const mutex = new Mutex();
const deviceId = localStorage.getItem("deviceId") || uuid();

const tagTypes = [
  "faculty",
  "subject",
  "mode",
  "level",
  "course",
  "payment-mode",
  "course-type",
  "attempt",
  "user",
  "admin",
  "offline-order",
  "category",
  "book",
  "product",
  "drawer",
  "student",
  "future-purchase",
  "followup-note",
  "due",
  "user-role",
  "coupons",
  "syllabus",
  "module",
  "group",
  "institute",
  "batch-type",
  "File",
];

const baseQuery = fetchBaseQuery({
  baseUrl: `${BASE_URL}`,
  prepareHeaders: (headers, { getState, endpoint }) => {
    const token =
      (getState() as RootState)?.auth?.accessToken ||
      localStorage.getItem(authTokenKeyName);
    if (token && endpoint !== "getAccessModules") {
      headers.set("x-access-token", token);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  await mutex.waitForUnlock();
  let result = await baseQuery(args, api, extraOptions);
  if (result?.error && result?.error?.status === 401) {
    if (!mutex?.isLocked()) {
      const release = await mutex.acquire();
      try {
        const refreshResult: any = await baseQuery(
          {
            url: "/admin/refresh",
            method: "POST",
            headers: {
              "device-id": deviceId,
            },
            body: { refreshToken: localStorage.getItem(refreshTokenKeyName) },
          },
          api,
          extraOptions
        );
        if (
          refreshResult?.error &&
          refreshResult?.error?.status === 400 &&
          refreshResult?.error?.status === 500
        ) {
          clearLocalStorage();
          window.location.replace("/");
        }
        if (refreshResult?.data) {
          localStorage.setItem(
            authTokenKeyName,
            refreshResult?.data?.data?.token
          );
          localStorage.setItem(
            refreshTokenKeyName,
            refreshResult?.data?.data?.refreshToken
          );
          api.dispatch(setAccessToken(refreshResult?.data?.data?.token));

          api.dispatch(
            setRefreshToken(refreshResult?.data?.data?.refreshToken)
          );
          // localStorage.setItem(
          //   "userData",
          //   JSON.stringify({
          //     name: refreshResult?.data?.data?.name,
          //     mobile: refreshResult?.data?.data?.mobile,
          //     email: refreshResult?.data?.data?.email,
          //     userId: refreshResult?.data?.data?.userId,
          //   })
          // );
          result = await baseQuery(args, api, extraOptions);
        } else {
          clearLocalStorage();
          window.location.replace("/");
        }
      } finally {
        release();
      }
    } else {
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extraOptions);
    }
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: "apiSlice",
  baseQuery: baseQueryWithReauth,
  tagTypes: tagTypes,
  endpoints: () => ({}),
});

export default apiSlice;
